import { Link, NavLink, Outlet } from "react-router-dom";
import { Activity, Database, FileText, Package, DollarSign, Users, FileEdit, Inbox, KeyRound, LayoutGrid, Globe, Quote } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Logo } from "@/components/Layout";

const LINKS = [
  { to: "/admin", label: "Usage & Revenue", icon: Activity, id: "usage", end: true },
  { to: "/admin/data", label: "Dashboard Data", icon: Database, id: "data" },
  { to: "/admin/reports", label: "Reports", icon: FileText, id: "reports" },
  { to: "/admin/products", label: "Products", icon: Package, id: "products" },
  { to: "/admin/pricing", label: "Module Pricing", icon: DollarSign, id: "pricing" },
  { to: "/admin/subscribers", label: "Subscribers", icon: Users, id: "subscribers" },
  { to: "/admin/pages", label: "Website Pages", icon: FileEdit, id: "pages" },
  { to: "/admin/testimonials", label: "Testimonials", icon: Quote, id: "testimonials" },
  { to: "/admin/enquiries", label: "Enquiries", icon: Inbox, id: "enquiries" },
  { to: "/admin/settings", label: "Settings", icon: KeyRound, id: "settings" },
];

export const inputCls = "h-9 rounded-md bg-slate-900 border border-slate-700 px-3 text-sm focus:outline-none focus:border-[#1074BA]";
export const btnPrimary = "px-4 h-9 rounded-md bg-[#1074BA] hover:bg-[#0D629E] text-white text-sm font-medium disabled:opacity-50";
export const btnGhost = "px-3 h-8 rounded-md border border-slate-700 hover:border-[#03AB9E] text-xs text-slate-300";

export default function AdminLayout() {
  return (
    <div className="min-h-screen grain relative flex">
      <aside className="w-60 shrink-0 border-r border-slate-800 bg-slate-950/90 sticky top-0 h-screen flex flex-col z-20">
        <Link to="/" className="p-5 block"><Logo className="h-8" /></Link>
        <p className="px-5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#F58B23] mb-2">CMS</p>
        <nav className="flex-1 px-3 space-y-0.5 overflow-y-auto">
          {LINKS.map(({ to, label, icon: Icon, id, end }) => (
            <NavLink key={id} to={to} end={end} data-testid={`admin-nav-${id}`}
              className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm ${isActive ? "bg-[#1074BA]/15 text-white" : "text-slate-400 hover:text-white hover:bg-slate-800/50"}`}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-800 space-y-0.5">
          <div className="flex items-center gap-2 px-1 text-xs text-slate-500"><ThemeToggle testId="admin-theme-toggle" />Theme</div>
          <Link to="/dashboards" className="flex items-center gap-2.5 px-3 py-2 text-sm text-slate-400 hover:text-white"><LayoutGrid className="h-4 w-4" />Dashboards</Link>
          <Link to="/" className="flex items-center gap-2.5 px-3 py-2 text-sm text-slate-400 hover:text-white"><Globe className="h-4 w-4" />Website</Link>
        </div>
      </aside>
      <main className="flex-1 relative z-10 p-6 md:p-8 min-w-0"><Outlet /></main>
    </div>
  );
}
